<template>
  <div
    class="mc-video-history-new__timeline-filled"
    :style="{
      width: `${widthPercentage}%`,
      left: `${startPercentage}%`,
    }"
  >
    <div
      v-if="hasBufferedRange"
      class="mc-video-history-new__timeline-filled-buffered"
      :style="bufferedStyle"
    ></div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    widthPercentage: {
      type: Number,
      required: true,
    },
    startPercentage: {
      type: Number,
      required: true,
    },
    startTime: {
      type: String,
      default: '',
    },
    endTime: {
      type: String,
      default: '',
    },
    startTimeBuffered: {
      type: String,
      default: '',
    },
    endTimeBuffered: {
      type: String,
      default: '',
    },
  },

  computed: {
    bufferedStyle() {
      const start = moment.utc(this.startTime)
      const end = moment.utc(this.endTime)
      const bufferedStart = moment.utc(this.startTimeBuffered)
      const bufferedEnd = moment.utc(this.endTimeBuffered)

      if (
        !start.isValid() ||
        !end.isValid() ||
        !bufferedStart.isValid() ||
        !bufferedEnd.isValid() ||
        !end.isAfter(start)
      ) {
        return this.emptyBufferedStyle
      }

      const startTimestamp = start.valueOf()
      const endTimestamp = end.valueOf()

      const intersectionStart = Math.max(startTimestamp, bufferedStart.valueOf())

      const intersectionEnd = Math.min(endTimestamp, bufferedEnd.valueOf())

      if (intersectionStart >= intersectionEnd) {
        return this.emptyBufferedStyle
      }

      const duration = endTimestamp - startTimestamp

      return {
        left: `${((intersectionStart - startTimestamp) / duration) * 100}%`,
        width: `${((intersectionEnd - intersectionStart) / duration) * 100}%`,
      }
    },

    hasBufferedRange() {
      return Number.parseFloat(this.bufferedStyle.width) > 0
    },

    emptyBufferedStyle() {
      return {
        left: '0%',
        width: '0%',
      }
    },
  },
}
</script>
